import { Card, CardContent, Typography } from '@mui/material';
import type { ReactNode } from 'react';

interface PageSectionProps {
  readonly title: string;
  readonly subtitle?: string;
  readonly children: ReactNode;
}

export default function PageSection({ title, subtitle, children }: PageSectionProps) {
  return (
    <Card sx={{ borderRadius: 3, boxShadow: '0 12px 30px rgba(15, 23, 42, 0.08)' }}>
      <CardContent>
        <Typography variant="h5" sx={{ fontWeight: 700, mb: subtitle ? 0.5 : 2 }}>
          {title}
        </Typography>
        {subtitle ? (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {subtitle}
          </Typography>
        ) : null}
        {children}
      </CardContent>
    </Card>
  );
}
